import {ReduxStateType} from '../store';

export const selectDistributedDeductions = (state: ReduxStateType) => {
  return state.distributeDeductions;
};
